export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > div:first-child': {
      pt: ['40px', '0px'],
    },
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    py: ['', '30px'],
    px: ['', '80px'],
  },
  partnershipTitle: {
    color: 'tmRed',
    fontFamily: 'spoqaBold',
    textAlign: 'left',
    fontSize: ['24px', '30px'],
  },
  videoTitle: {
    color: 'tmBlue',
    fontWeight: 900,
    textAlign: 'center',
    fontSize: ['1.2rem', '1.4rem'],
    paddingBottom: ['10px', '20px'],
  },
  videoContainer: {
    width: ['100%', '35%'],
    height: ['200px', '220px'],
    backgroundColor: 'tmBlue',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  partnershipDescription: {
    display: 'inline-block',
    color: 'tmBlue',
    fontSize: ['0.9rem', '1.3rem'],
    fontFamily: 'spoqaRegular',
    pt: ['12px', '30px'],
    pb: '0px',
  },
}
